import { useTrial } from '../TrialProvider'

export function TrialError() {
	const { errorMsg } = useTrial()

	if (!errorMsg) {
		return null
	}

	return <div className="text-bc-pink font-medium pt-10">{errorMsg} </div>
}
